export default __webpack_public_path__ + "static/media/record.bbbc20a4.svg";